module.exports = "<template> <div class=\"text-right number-display\" style.bind=\"value | fieldColor:column\">${ value | percentage }</div> </template> ";